import React, {Fragment} from 'react';
import {AutoComplete, Button, Card, Form, Input, Modal, notification, Select, Space, Typography} from "antd";

import ApiService from "../../services/ApiService"
import IntlMessage from "../../components/util-components/IntlMessage";
import {getContactAdresses, getContactTels} from "./functions";
import {t} from "@lingui/core/macro"
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {Trans} from "@lingui/react/macro";
import StaredField from "../../components/custom-fields/Stared";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {EsriProvider} from "leaflet-geosearch";
import {getCountry} from "../../components/permissions/functions";
import {uuid} from "short-uuid";

const provider = new EsriProvider();
const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalEditAdresses extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contactId: null,
        id: null,
        edit: false,
        defaultData: {},
        adresseOptions: []
    };

    state = this.initialState;

    async show(contact={}) {
        console.log(contact)
        if (contact.id)
        {
            const adresses=getContactAdresses(contact)
            const mainIndex=adresses.findIndex(i=>i.main) || 0

            console.log("mainIndex",mainIndex)

            this.setState({
                visible: true,
                edit: true,
                contact: contact,
                id: contact.id,
                mainIndex: mainIndex,
                defaultData: {adresses:adresses}
            })
        } else {
            //this.setState({visible: true, adresses: adresses, contactId: contactId})
        }
    }

    close() {
        this.setState(this.initialState)
    }


    getFinalData(data)
    {

        let object={

            adresses:[],
        }

        let i=0
        for(let a of data.adresses)
        {
            const item={
                siren:a.siren || null,
                adresse:a.adresse || null,
                postal:a.postal || null,
                ville:a.ville || null,
                pays:a.pays || null,
                note_adresse:a.note_adresse || null,
            }

            console.log(item)

            if(this.state.mainIndex===i){
                item.adresseNom=a.nom || null;
                object={...object,...item}
            }else{
                item.id=a.id || uuid();
                item.nom=a.nom || null;
                object.adresses.push(item)
            }

            i++
        }

        return object
    }


    async onSubmit(data) {

        const finalData=this.getFinalData(data)
        console.log(data,finalData)

        //return false

        this.setState({loading: true})

        var res = await ApiService.post("/contact/edit/partial/" + this.state.id, finalData)
        console.log(res)

        if (res.success) {
            if (res.message) {
                notification.warn({
                    message: res.message
                })
            } else {
                notification.success({
                    message: this.state.edit ? (<IntlMessage id="success.edit"/>) : (<IntlMessage id="success.add"/>)
                })
            }

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.data)
            }
        } else {
            notification.success({
                message: this.state.edit ? (<IntlMessage id="error.edit"/>) : (<IntlMessage id="error.add"/>)
            })
        }

        this.setState({loading: false})
    }

    render()
    {

        return (
            <Modal width="100%" title={<span>{this.state.id ? <Trans>Editer</Trans> : <Trans>Ajouter</Trans>} <Trans>les adresses</Trans></span>}
                   open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                    initialValues={this.state.defaultData}
                >

                    <Form.List name="adresses">
                        {(fields, {add, remove}) => (
                            <Space direction={"vertical"} size={"large"} style={{width:"100%"}}>

                            {fields.map(({key, name, ...restField}) => (
                                <Form.Item noStyle shouldUpdate>
                                    {(_form)=>{
                                        const title=_form.getFieldValue(["adresses",key,"nom"])
                                        //console.log("title",title)

                                        return(
                                            <Card title={title} key={key} type={"inner"} extra={(
                                                <Space>
                                                    <StaredField value={(this.state.mainIndex || 0)==name} onChange={(v)=>this.setState({mainIndex:name})}/>
                                                    <MinusCircleOutlined color={"red"} onClick={() => remove(name)}/>
                                                </Space>
                                            )}>

                                                <Form.Item
                                                    label="Nom ou Raison social"
                                                    name={[name,"nom"]}
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <Input placeholder="Bureau, Domicile Etc."/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Siren"
                                                    name={[name,"siren"]}
                                                >
                                                    <Input placeholder="(Optionnelle)"/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Adresse"
                                                    name={[name,"adresse"]}
                                                >
                                                    <AutoComplete
                                                        options={this.state.adresseOptions.map(i => {
                                                            return {
                                                                object: i,
                                                                value: i.adresse,
                                                                label: i.raw,
                                                            }
                                                        })}
                                                        onSearch={(inputValue) => {
                                                            clearTimeout(this.timeoutAdresse)
                                                            this.timeoutAdresse = setTimeout(async () => {
                                                                var value = inputValue.trim()
                                                                console.log(value)
                                                                if (value) {
                                                                    var results = await provider.search({query: value})
                                                                    console.log(results)

                                                                    var finalResult = results.map((item) => {
                                                                        var arrayValue = item.label.split(",")
                                                                        console.log(arrayValue)
                                                                        return {
                                                                            raw: item.label,
                                                                            adresse: arrayValue[0],
                                                                            postal: arrayValue[1],
                                                                            ville: arrayValue[2],
                                                                        }
                                                                    })

                                                                    this.setState({adresseOptions: finalResult})
                                                                }
                                                            }, 500)
                                                        }}
                                                        onSelect={(value, option) => {
                                                            console.log(option)
                                                            this.form.setFieldValue(["adresses",name,"postal"], option.object.postal)
                                                            this.form.setFieldValue(["adresses",name,"ville"], option.object.ville)
                                                        }}
                                                        placeholder="Adresse"
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    label="Code Postal"
                                                    name={[name,"postal"]}
                                                >
                                                    <Input placeholder="Code Postal"/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Ville"
                                                    name={[name,"ville"]}
                                                >
                                                    <Input placeholder="Ville"/>
                                                </Form.Item>

                                                <Form.Item
                                                    label="Pays"
                                                    name={[name,"pays"]}
                                                >
                                                    <Select showSearch placeholder="Pays">
                                                        {COUNTRY.map(i=>{
                                                            return(
                                                                <Select.Option value={i.country}>{i.country}</Select.Option>
                                                            )
                                                        })}
                                                    </Select>
                                                </Form.Item>


                                                <Form.Item
                                                    label="Note"
                                                    name={[name,"note_adresse"]}
                                                >
                                                    <Input.TextArea placeholder="(Optionnelle)"/>
                                                </Form.Item>

                                            </Card>
                                        )
                                    }}
                                </Form.Item>
                                ))}


                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block
                                            icon={<PlusOutlined/>}>
                                        <Trans>Ajouter une Adresse</Trans>
                                    </Button>
                                </Form.Item>
                            </Space>
                        )}
                    </Form.List>




                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>

            </Modal>
        )
    }
}
